import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function TermsOfService() {
  return (
    <div style={{ maxWidth: 800, margin: '0 auto', padding: '40px 24px 80px' }}>
      <Link to="/" style={{ display: 'inline-flex', alignItems: 'center', gap: 8, color: '#0D9488', textDecoration: 'none', marginBottom: 24 }}>
        <ArrowLeft size={18} /> Back to Home
      </Link>

      <h1 style={{ fontSize: 32, fontWeight: 700, marginBottom: 8 }}>Terms of Service</h1>
      <p style={{ color: '#6B7280', marginBottom: 32 }}>Last updated: August 5, 2026</p>

      <div style={{ lineHeight: 1.8, color: '#374151' }}>
        <h2 style={{ fontSize: 22, fontWeight: 600, marginTop: 32, marginBottom: 12 }}>1. Acceptance of Terms</h2>
        <p>By accessing or using the ElderLink platform at elderlinkapp.com, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our platform.</p>

        <h2 style={{ fontSize: 22, fontWeight: 600, marginTop: 32, marginBottom: 12 }}>2. Description of Service</h2>
        <p>ElderLink is a caregiving coordination platform that helps families and caregivers manage elder care. The platform provides tools for scheduling, communication, health tracking, shift management, and care coordination.</p>

        <h2 style={{ fontSize: 22, fontWeight: 600, marginTop: 32, marginBottom: 12 }}>3. User Accounts</h2>
        <p>To use ElderLink, you must create an account with accurate and complete information. You are responsible for:</p>
        <ul style={{ paddingLeft: 24, marginBottom: 16 }}>
          <li>Maintaining the confidentiality of your account credentials</li>
          <li>All activities that occur under your account</li>
          <li>Notifying us immediately of any unauthorized use</li>
        </ul>

        <h2 style={{ fontSize: 22, fontWeight: 600, marginTop: 32, marginBottom: 12 }}>4. Acceptable Use</h2>
        <p>You agree to use ElderLink only for its intended purpose of care coordination. You may not:</p>
        <ul style={{ paddingLeft: 24, marginBottom: 16 }}>
          <li>Use the platform for any unlawful purpose</li>
          <li>Share or disclose care recipients' private health information outside the platform</li>
          <li>Attempt to gain unauthorized access to other users' accounts</li>
          <li>Upload malicious content or interfere with the platform's operation</li>
          <li>Use the platform to harass, abuse, or harm others</li>
        </ul>

        <h2 style={{ fontSize: 22, fontWeight: 600, marginTop: 32, marginBottom: 12 }}>5. Care Coordination</h2>
        <p>ElderLink is a coordination tool and does not provide medical advice, diagnosis, or treatment. Users are responsible for making their own care decisions. ElderLink is not a substitute for professional medical care.</p>

        <h2 style={{ fontSize: 22, fontWeight: 600, marginTop: 32, marginBottom: 12 }}>6. Subscriptions and Payments</h2>
        <p>Some features of ElderLink may require a paid subscription. Payment terms, billing cycles, and cancellation policies are presented at the time of subscription. All fees are non-refundable unless otherwise stated.</p>

        <h2 style={{ fontSize: 22, fontWeight: 600, marginTop: 32, marginBottom: 12 }}>7. Third-Party Integrations</h2>
        <p>ElderLink integrates with third-party services such as Google Calendar, Twilio (SMS), and Stripe (payments). Your use of these integrations is subject to the respective third-party terms of service. We are not responsible for third-party service availability or performance.</p>

        <h2 style={{ fontSize: 22, fontWeight: 600, marginTop: 32, marginBottom: 12 }}>8. Intellectual Property</h2>
        <p>The ElderLink platform, including its design, code, and content, is owned by ElderLink. You retain ownership of the data and content you submit through the platform.</p>

        <h2 style={{ fontSize: 22, fontWeight: 600, marginTop: 32, marginBottom: 12 }}>9. Limitation of Liability</h2>
        <p>ElderLink is provided "as is" without warranties of any kind. To the maximum extent permitted by law, ElderLink shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of the platform.</p>

        <h2 style={{ fontSize: 22, fontWeight: 600, marginTop: 32, marginBottom: 12 }}>10. Termination</h2>
        <p>We reserve the right to suspend or terminate your account if you violate these terms. You may delete your account at any time through your account settings or by contacting support.</p>

        <h2 style={{ fontSize: 22, fontWeight: 600, marginTop: 32, marginBottom: 12 }}>11. Changes to Terms</h2>
        <p>We may update these Terms of Service from time to time. Continued use of the platform after changes constitutes acceptance of the updated terms.</p>

        <h2 style={{ fontSize: 22, fontWeight: 600, marginTop: 32, marginBottom: 12 }}>12. Contact</h2>
        <p>For questions about these Terms of Service, contact us at <a href="mailto:elderlinksupport@gmail.com" style={{ color: '#0D9488' }}>elderlinksupport@gmail.com</a>.</p>
      </div>
    </div>
  );
}
